/**
 * AndVRose - 玫瑰图组件
 * 基于 Ant Design Charts Rose
 */
import React from 'react';
import { Rose } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVRoseProps } from '../base/types';

const DEFAULT_ROSE_DATA = [
  { category: '分类一', value: 27 },
  { category: '分类二', value: 25 },
  { category: '分类三', value: 18 },
  { category: '分类四', value: 15 },
  { category: '分类五', value: 10 },
];

const RoseWithBase = withBaseChart<AndVRoseProps>(Rose, {
  chartType: 'AndVRose',
  defaultHeight: 300,
  defaultData: DEFAULT_ROSE_DATA,
});

export const AndVRose: React.FC<AndVRoseProps> = (props) => {
  const {
    xField = 'category',
    yField = 'value',
    colorField,
    radius,
    innerRadius,
    stack,
    group,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    xField,
    yField,
  };

  if (colorField) chartProps.colorField = colorField;
  if (radius !== undefined) chartProps.radius = radius;
  if (innerRadius !== undefined) chartProps.innerRadius = innerRadius;
  if (stack !== undefined) chartProps.stack = stack;
  if (group !== undefined) chartProps.group = group;

  return <RoseWithBase {...chartProps} />;
};

export type { AndVRoseProps };
export default AndVRose;
